<template>
  <div>
    <div>
      <div class="btn-group btn-group-toggle">
        <label
          v-if="operator"
          class="btn btn-light text-left"
          :class="{active: suggestedUser && suggestedUser.id === operator.id}"
        >
          <input type="radio" autocomplete="off" v-model="suggestedUser" :value="operator">
          <small class="text-uppercase">Оператор автомата</small>
          <br>
          {{ operator | fullName }}
        </label>
        <label
          class="btn btn-light text-left"
          :class="{active: suggestedUser && suggestedUser.id === tech.id}"
          v-if="tech && (!operator || operator.id !== tech.id)"
        >
          <input type="radio" autocomplete="off" v-model="suggestedUser" :value="tech">
          <small class="text-uppercase">Техник автомата</small>
          <br>
          {{ tech | fullName }}
        </label>
        <label
          class="btn btn-light text-left d-inline-flex align-items-center"
          :class="{active: suggestedUser === false}"
        >
          <input type="radio" autocomplete="off" v-model="suggestedUser" :value="false">
          Выбрать...
        </label>
      </div>
    </div>

    <server-select
      v-if="suggestedUser === false"
      class="mt-2"
      :disabled="disabled"
      v-model="selectedUser"
      :custom-label="fullName"
      placeholder="Выберите исполнителя..."
      endpoint="users_by_role"
      :endpoint-params="{role: ['tech', 'service', 'tech_superior', 'service_superior'], region_id: regionId}"
    />
  </div>
</template>

<script>
  import filters from '../filters'
  import ServerSelect from './server-select'

  export default {
    name: 'service-user-select',
    components: {ServerSelect},
    props: {
      value: {},
      operator: {},
      tech: {},
      disabled: {},
      regionId: {},
    },
    data () {
      let suggestedUser = null
      let selectedUser = null

      if (this.value) {
        suggestedUser = [this.operator, this.tech].find((s) => s && s.id === this.value.id) || false
        if (!suggestedUser) {
          selectedUser = this.value
        }
      }

      return {
        suggestedUser,
        selectedUser,
      }
    },
    computed: {
      fullName: () => filters.fullName,
      selectedValue () {
        return this.suggestedUser || this.selectedUser || null
      },
    },
    watch: {
      suggestedUser () {
        this.selectedUser = null
      },
      selectedValue (value) {
        this.$emit('input', value)
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/service-user-select.vue